import Skeleton from "@mui/material/Skeleton";
import MKBox from "components/MKBox";

function PostSkeleton() {
  return (
    <MKBox>
      <MKBox display="flex" alignItems="center" p={2}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="text" width="40%" sx={{ ml: 2 }} />
      </MKBox>
      <Skeleton
        variant="rectangular"
        width="100%"
        sx={{ aspectRatio: "1 / 1", mt: -1, mb: -1 }}
      />
      <MKBox p={2}>
        <Skeleton variant="text" />
        <Skeleton variant="text" width="80%" />
      </MKBox>
    </MKBox>
  );
}

export default PostSkeleton;

